import { render } from "./d-betview.vue?vue&type=template&id=5782dac4&ts=true"
import script from "./d-betview.vue?vue&type=script&lang=ts"
export * from "./d-betview.vue?vue&type=script&lang=ts"

import "./d-betview.vue?vue&type=style&index=0&id=5782dac4&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__